// Enum for sidebar mode.
export enum EMobileMode {
	Calendar,
	Details,
	Search,
}
